import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import styles from './App.module.css';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import React from 'react';

import packageJson from '../package.json';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import { useAuth } from './AuthContext';
import { ProtectedRoutes } from './ProtectedRoutes';
import { ActionBar } from './components/ActionBar/ActionBar';
import { LogInWrapper } from './components/LogInWrapper/LogInWrapper';
import { Dashboard } from './components/Dashboard/Dashboard';

const getAppTitle = () => {
    const appName = "Patrol Notify";
    const environment = process.env.NODE_ENV !== "production"
        ? "DEV"
        : window.location.hostname.endsWith(".web.app")
            ? "STAGING"
            : "PROD";

    const windowTitle = environment === "PROD"
        ? `${ appName } | Patrol360`
        : `${ environment } - ${ appName }`;

    const pageTitle = appName;

    return { windowTitle, pageTitle, environment };
};

const Footer = () => {
    return (
        <footer className={ styles.footer }>
            <Stack spacing={ 2 } justifyContent="center" alignItems="center">
                <Typography variant="caption" sx={ { color: 'text.primary' } }>
                    &copy; 2023-{ new Date().getFullYear() } | Patrol360
                </Typography>
            </Stack>
        </footer>
    );
};

const Content = () => {
    return (
        <Routes>
            <Route path="/" element={ <LogInWrapper /> } />
            <Route element={ <ProtectedRoutes /> }>
                <Route path="/dashboard" element={ <Dashboard /> } />
            </Route>
            <Route path="*" element={ <LogInWrapper /> } />
        </Routes>
    );
};

export default function App() {
    const [ error, setError ] = React.useState(false);
    const [ versions, setVersions ] = React.useState({ site: null, api: null, commit: null });
    
    const { auth, signOutUser } = useAuth();

    React.useEffect(() => {
        const fetchVersions = async () => {
            try {
                const response = await fetch(`${ process.env.REACT_APP_API_ENDPOINT }/api/version`);
                const data = await response.json();

                setVersions({ site: packageJson.version, api: data.version, commit: data.commit });
            } catch (err) {
                setError(err);
                setVersions(null);
            }
        };

        fetchVersions();
    }, []);

    const handleLogOut = async () => {
        await signOutUser();
    };

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
        },
    });

    document.title = getAppTitle().windowTitle;

    if (error) {
        console.error(error);
    }

    return (
        <ThemeProvider theme={ darkTheme }>
            <div className={ styles.app }>
                <BrowserRouter
                    future={ {
                        v7_startTransition: true,
                        v7_relativeSplatPath: true,
                    } }>

                    <ActionBar auth={ auth } title={ getAppTitle().pageTitle } environment={ getAppTitle().environment } versions={ versions } onLogOut={ handleLogOut } />

                    <main className={ styles.content }>
                        <Content />
                    </main>

                    <Footer />

                </BrowserRouter>
            </div>
        </ThemeProvider>
    );
};